export default __webpack_public_path__ + "static/media/brick-wall.4f40a242.svg";